import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { FsWhoosterAddressModel } from '../models/whooster-address.model';
import { FsWhoosterHistoryModel } from '../models/whooster-history.model';
import { FsWhoosterPhoneModel } from '../models/whooster-phone.model';

@Injectable({
  providedIn: 'root',
})
export class SnWhoosterService {
  constructor(private readonly _httpClient: HttpClient) {}

  public isArrays(item: any): boolean {
    return Array.isArray(item);
  }

  public createWhooster(params: any): Observable<any> {
    return this._httpClient.post('/api/integrations/whooster/search/', params);
  }

  public getWhoosterAddress(id: any): Observable<any> {
    return this._httpClient
      .get(`/api/integrations/whooster/search/${id}/`, { observe: 'response' })
      .pipe(
        map((response: any) => {
          const res = {
            results: response.body,
            status: response.status,
            addressArray: [],
          };
          const persons = response.body.searchResponse?.lookupPerson?.people?.person || [];
          if (this.isArrays(persons) && persons.length > 0) {
            res['addressArray'] = response.body.searchResponse?.lookupPerson?.people?.person.map(
              (item: any) => new FsWhoosterAddressModel(item),
            );
          }
          if (!this.isArrays(persons) && persons) {
            res['addressArray'] = [
              new FsWhoosterAddressModel(
                response.body.searchResponse?.lookupPerson?.people?.person,
              ),
            ];
          }
          return res;
        }),
      );
  }

  public getWhoosterPhone(id: any): Observable<any> {
    return this._httpClient
      .get(`/api/integrations/whooster/search/${id}/`, { observe: 'response' })
      .pipe(
        map((response: any) => {
          const res = {
            results: response.body,
            status: response.status,
            phoneArray: [],
          };
          const persons = response.body.searchResponse?.lookupPerson?.people?.person || undefined;
          if (this.isArrays(persons) && persons.length > 0) {
            res['phoneArray'] = response.body.searchResponse?.lookupPerson?.people?.person.map(
              (item: any) => new FsWhoosterPhoneModel(item),
            );
          }
          if (!this.isArrays(persons) && persons) {
            res['phoneArray'] = [
              new FsWhoosterPhoneModel(response.body.searchResponse?.lookupPerson?.people?.person),
            ];
          }
          return res;
        }),
      );
  }

  public getWhoosterHistory(): Observable<any> {
    return this._httpClient.get('/api/integrations/whooster/search/').pipe(
      map((response: any) => ({
        results: response?.results.map((item) => new FsWhoosterHistoryModel(item)),
      })),
    );
  }

  public whoosterPdf(whoosterId: String): Observable<any> {
    return this._httpClient.post(
      `/api/integrations/whooster/search/${whoosterId}/export_pdf/`,
      null,
    );
  }
}
